export default "__VITE_ASSET__DSmXOyY$__"